import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subscription, timer } from 'rxjs';
import { SessionService } from 'src/app/lib/shared/services/session.service';
import { RootService } from 'src/app/services/root.service';

@Component({
  selector: 'app-complete-password-reset',
  templateUrl: './complete-password-reset.component.html',
  styleUrls: ['./complete-password-reset.component.css']
})
export class CompletePasswordResetComponent implements OnDestroy, OnInit {

  appearance = 'fill';

  formGroup: FormGroup;

  guid = null;

  private _subscriptions: Subscription[] = [];

  constructor(
    private _route: ActivatedRoute,
    private _rootService: RootService,
    private _formBuilder: FormBuilder,
    private _sessionService: SessionService,
    private _snackBar: MatSnackBar,
    private _router: Router
  ) {
    this.formGroup = this._formBuilder.group({
      'password': null,
      'confirmPassword': null,
      'code': null,
      'guid': null
    });
  }

  confirm(){
    this._sessionService.confirmPasswordReset(this.formGroup.value).subscribe({
      next: () => {
        this._snackBar.open('Ihr Passwort wurde geändert', 'Ok', {
          duration: 2000
        });
        timer(2500).subscribe(() => this._router.navigate(['/login']));
      },
      error: (error: HttpErrorResponse) => {
        this._snackBar.open('Das hat nicht geklappt', 'Ok', {
          duration: 2000
        });
      }
    });
  }

  ngOnDestroy(): void {
    for (let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this._rootService.hideNavbar();
    this._subscriptions.push(
      this._route.params.subscribe((params: Params) => this.formGroup.controls['guid'].setValue(params['id']))
    );
  }

}
